<template>
  <div class="qr-code" :style="divStyle">
    <img class="qr-img" :style="imgStyle" :src="imgCodePath" alt="" />
  </div>
</template>

<script>
export default {
  name: 'QrCode',
  props: {
    width: { type: Number, default: 220 },
    height: { type: Number, default: 220 },
    imgWidth: { type: Number, default: 220 },
    imgHeight: { type: Number, default: 220 },
    content: { type: String },
  },
  data() {
    return {
      api: this.$store.state.api,
    }
  },
  computed: {
    divStyle() {
      return 'width: ' + this.width + 'px !important; height: ' + this.height + 'px !important;'
    },
    imgStyle() {
      return 'width: ' + this.imgWidth + 'px !important; height: ' + this.imgHeight + 'px !important;'
    },
    imgCodePath() {
      return this.api + '/curr/createCoreImg-0?content=' + this.content + '&ms=' + Date.now()
    },
  },
}
</script>

<style lang="less" scoped>
.qr-code {
  display: flex !important;
  align-items: center !important;
}

.qr-img {
  margin: 0 auto !important;
}
</style>

<style lang="less"></style>
